<template>
  <VTableSearch :searchString="searchString" @filter="onFilter"> </VTableSearch>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash/debounce";

import VTableSearch from "@/components/VTableSearch";

export default Vue.component("CampaignsFilter", {
  components: {
    VTableSearch
  },

  data() {
    return {
      debouncedFilterContacts: debounce(this.filterCampaigns, 300)
    };
  },

  methods: {
    filterCampaigns(value) {
      this.fetchCampaigns({
        page: 1,
        search: value
      });
    },

    onFilter(value) {
      this.changeSearchString(value);
      this.debouncedFilterContacts(value);
    },

    ...mapActions("campaigns", ["fetchCampaigns", "changeSearchString"])
  },

  computed: {
    ...mapGetters("campaigns", ["searchString", "currentPage", "sorting"])
  },

  destroyed() {
    this.changeSearchString("");
  }
});
</script>
